import { fromJS, List } from 'immutable';
import {
  LOAD_PROJECT_ACTIVITY_LOG_SUCCESS,
  LOAD_TASK_ACTIVITY_LOG_SUCCESS,
  TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS,
  VIEW_NOTIFICATION_SUCCESS,
  LOAD_ACTIVITY_LOG_PROJECT_LIST_SUCCESS,
  APPEND_ACTIVITY_LOG,
  APPEND_NEW_FEED,
} from 'constants/ActionTypes';
import { normalizeEntities } from 'helpers/utilHelpers';

const initialState = fromJS({
  projectOrderIds: [],
  logs: {},
  taskLogs: {
    logs: {},
    pagination: {},
  },
});

const updateLogs = (state, feed) => {
  if (!feed?.projectId || !feed?.activityId) {
    return state;
  }

  let newState = state;
  let logs = newState.getIn(['logs', String(feed.projectId), 'logs']);

  if (logs?.size) {
    logs = logs.map((log) => {
      if (log.get('logId') === feed.activityId) {
        return log.set('existFeed', false);
      }
      return log;
    });

    newState = newState.setIn(['logs', String(feed.projectId), 'logs'], logs);
  }

  let taskLogs = newState.getIn(['taskLogs', 'logs']);
  if (taskLogs?.size && taskLogs.get(feed.activityId)) {
    taskLogs = taskLogs.setIn([feed.activityId, 'existFeed'], false);
    newState = newState.setIn(['taskLogs', 'logs'], taskLogs);
  }

  return newState;
};

const prepareLog = (activityLog) => {
  if (activityLog?.comment?.files?.length) {
    activityLog.comment.files = activityLog.comment.files.map((file) => file.fileId);
  }
  return activityLog;
};

const activityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_NOTIFICATION_SUCCESS:
      return updateLogs(state, action.notification);
    case TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS: {
      let newState = state;
      action.values.forEach((notification) => {
        newState = updateLogs(newState, notification);
      });

      return newState;
    }

    case APPEND_ACTIVITY_LOG: {
      let projectOrderIds = state.get('projectOrderIds');
      const projectId = String(action.payload.projectId);
      if (!projectOrderIds) {
        projectOrderIds = List(projectId);
      } else {
        projectOrderIds = projectOrderIds.filter((id) => id !== projectId);
        projectOrderIds = projectOrderIds.unshift(projectId);
      }

      let newState = state.set('projectOrderIds', projectOrderIds);

      // Пришлось клонировать данный объект т.к. функция prepareComment в commentReducer
      // обновляется массив `action.payload.comment.files` и
      // там снова нужны fileId, а тут мы от него избавляемся
      const activityLogCopy = JSON.parse(JSON.stringify(action.payload));

      const projectLogsPath = ['logs', projectId, 'logs'];
      if (state.getIn(projectLogsPath)) {
        newState = newState.setIn(projectLogsPath, state.getIn(projectLogsPath).push(fromJS(activityLogCopy)));
      }

      const { entity } = action.payload;
      if (entity === 'Comment') {
        return newState;
      }

      return newState.setIn(
        ['taskLogs', 'logs'],
        normalizeEntities([prepareLog(activityLogCopy)], 'logId', state.getIn(['taskLogs', 'logs']), ['comment'], {
          skipFields: ['comment'],
        }),
      );
    }

    case LOAD_ACTIVITY_LOG_PROJECT_LIST_SUCCESS: {
      return state.set('projectOrderIds', fromJS(action.logs));
    }

    case LOAD_PROJECT_ACTIVITY_LOG_SUCCESS: {
      const requestMeta = action.logs._meta;
      if (state.getIn(['logs', String(action.projectId)])) {
        return state
          .setIn(['logs', String(action.projectId), 'page'], requestMeta.currentPage)
          .setIn(['logs', String(action.projectId), 'hasMore'], requestMeta.pageCount > requestMeta.currentPage)
          .setIn(
            ['logs', String(action.projectId), 'logs'],
            state
              .getIn(['logs', String(action.projectId), 'logs'])
              .merge(
                fromJS(
                  action.logs.items?.filter(
                    (log) =>
                      !state
                        .getIn(['logs', String(action.projectId), 'logs'])
                        ?.find((item) => item.get('logId') === log.logId),
                  ),
                ),
              ),
          );
      }

      return state.setIn(
        ['logs', String(action.projectId)],
        fromJS({
          hasMore: requestMeta.pageCount > requestMeta.currentPage,
          page: 1,
          logs: action.logs.items,
        }),
      );
    }
    case LOAD_TASK_ACTIVITY_LOG_SUCCESS: {
      let newState = state.setIn(
        ['taskLogs', 'logs'],
        normalizeEntities(action.logs.items.map(prepareLog), 'logId', state.getIn(['taskLogs', 'logs']), ['comment'], {
          skipFields: ['comment'],
        }),
      );

      const entityPagination = state.getIn(['taskLogs', 'pagination', action?.taskId]);

      if (
        !entityPagination?.get('currentPage') ||
        action.logs._meta.currentPage > entityPagination?.get('currentPage')
      ) {
        newState = newState.setIn(
          ['taskLogs', 'pagination', action?.taskId],
          fromJS({
            totalCount: action.logs._meta.totalCount,
            pageCount: action.logs._meta.pageCount,
            currentPage: action.logs._meta.currentPage,
            perPage: action.logs._meta.perPage,
          }),
        );
      }
      return newState;
    }

    case APPEND_NEW_FEED: {
      const { activityId, projectId, viewed } = action.payload;

      let newState = state;
      const projectLogPath = ['logs', String(projectId), 'logs'];
      if (state.getIn(projectLogPath)) {
        const index = state.getIn(projectLogPath).findIndex((log) => log.get('logId') === activityId);
        if (index !== -1) {
          newState = newState.setIn([...projectLogPath, index, 'existFeed'], !viewed);
        }
      }

      const logPath = ['taskLogs', 'logs', activityId];
      if (newState.getIn(logPath)) {
        newState = newState.setIn([...logPath, 'existFeed'], !viewed);
      }

      return newState;
    }

    default:
      return state;
  }
};

export default activityLogReducer;
